const DB_NAME = "kintsugi-audio";
const STORE = "pending";

const open = () => new Promise((resolve, reject) => {
  const req = indexedDB.open(DB_NAME, 1);
  req.onupgradeneeded = () => { if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE, { keyPath: "reportId" }); };
  req.onsuccess = () => resolve(req.result);
  req.onerror = () => reject(req.error);
});

const tx = async (mode, fn) => {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const req = fn(t.objectStore(STORE));
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
};

export const savePendingAudio = (reportId, blob, meta) => tx("readwrite", (s) => s.put({ reportId, blob, meta, savedAt: Date.now(), size: blob.size }));
export const getPendingAudio = (reportId) => tx("readonly", (s) => s.get(reportId));
export const deletePendingAudio = (reportId) => tx("readwrite", (s) => s.delete(reportId));
export const listPendingAudio = () => tx("readonly", (s) => s.getAll());
